import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`General Errors`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error ID`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Recovery Suggestion`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid-value`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when the required data for specific use cases has an invalid format or is missing.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify the data format and ensure all required data is provided.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid-client-session-value`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when the required client session data for specific use cases has an invalid format or is missing.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify the client session data format and ensure all required data is provided when calling `}<a parentName="td" {...{
              "href": "https://primer.io/docs/api/api-reference/client-session-api/create-client-side-token"
            }}>{`Create a client session`}</a>{` API call.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`failed-to-update-client-session`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when the client session fails to update (e.g., selecting a payment method due to a surcharge being present, updating the billing address captured from Google Pay).`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Check the session update parameters and retry.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unknown-error`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when the SDK catches an unmapped `}<inlineCode parentName="td">{`Exception`}</inlineCode>{`.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contact Primer and provide us with diagnostics id.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      